import * as Sentry from "@sentry/browser";

export function sendSentryError(error: Error) {
  console.error("Sending sentry error");
  console.error(error);
  Sentry.withScope(scope => {
    scope.setLevel(Sentry.Severity.Error);
    Sentry.captureException(error);
  });
}